import { Button, Col, message, Modal, Row, Select, Space } from "antd"
import React, { useEffect, useState } from "react";
import { filterOption } from "../../../utils/funcHelper";

const ModalExportOrderSelected = ({ visible, onCancel, onSave, printers }) => {
    const [supplier_id, setSupplierId] = useState();

    const handleSave = () => {
        if (!supplier_id) {
            message.error('Vui lòng chọn nhà in để xuất excel');
            return;
        }
        onSave({ supplier_id: supplier_id });
        onCancel();
    }

    useEffect(() => {
        setSupplierId(null);
    }, [visible])

    return (
        <Modal
            title={'Xuất excel đơn hàng theo nhà in'}
            open={visible}
            onCancel={onCancel}
            width={'50%'}
            footer={null}
        >
            <Row gutter={16} style={{ marginBottom: 10 }}>
                <Col span={24}>
                    <Select
                        showSearch
                        allowClear
                        value={supplier_id}
                        onChange={(value) => setSupplierId(value)}
                        placeholder={'Chọn nhà in'}
                        style={{ width: '100%', height: 40 }}
                        defaultActiveFirstOption={false}
                        filterOption={filterOption}
                        notFoundContent={null}
                        options={printers?.map((item, index) => ({ value: item?.id, label: `${index + 1}. ${item?.name}` }))}
                    />

                </Col>

            </Row>
            <Row gutter={16} justify={'end'}>
                <Space>
                    <Button onClick={onCancel}>
                        Cancel
                    </Button>
                    <Button type="primary" onClick={handleSave}>
                        Save
                    </Button>
                </Space>
            </Row>
        </Modal>
    )
}
export default React.memo(ModalExportOrderSelected);

